
$.fn.getBackgroundColor = function() {
    return $(this).css('background-color');
}
